// extracted by mini-css-extract-plugin
export var article = "article-module--article--p5VIO";
export var fullWidth = "article-module--fullWidth--0sVix";
export var details = "article-module--details--Itq9Z";
export var addShadow = "article-module--addShadow--SW1BK";
export var right = "article-module--right--pLAbt";
export var image = "article-module--image--qZezT";